import React from 'react';
// logic
import useTicketFormSettings from '../components/ticketForm/useTicketFormSettings';
// components
import PortalContent from '../components/ui/portal/portalContent';
import TicketForm from '../components/ticketForm/ticketForm';
import BasicLoader from '../components/ui/loaders/basicLoader';
import TicketDetailToolbar from '../components/ticketDetail/ticketDetailToolbar';
import useTicketDetail from '../components/ticketDetail/useTicketDetail';
import PremiumSectionContainer from '../components/ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../components/ticketForm/components/PremiumSection';
import { InfoMessage } from '../components/ticketForm/components/InfoMessage';
import LogsList from '../components/log/LogsList';
// styles
import TicketPageContainer from '../components/ui/containers/ticketPageContainer';

const TicketDetailPage = ({ ...props }) => {
  const id = props.match.params.id;
  const { isLoadingTicketFormSettings, ticketFormSettings } = useTicketFormSettings();
  const {
    ticketDetail,
    isLoadingTicketDetail,
    isQuoteAccepted,
    ticketDetailError,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isCancellable,
    isDone,
    isDraft,
    draftErrors,
    onSubmit,
    onCancel,
    onCancelTicket,
    onMarkTicketAsDone,
    mutate,
  } = useTicketDetail({ id });

  const ticketFormData = {
    ticketFormSettings,
    validationSchema,
    initialValues,
    ticketDetail,
    isQuoteAccepted,
    isReadOnly,
    isEdit,
    isCancellable,
    isDone,
    isDraft,
    draftErrors,
    onSubmit,
    onCancel,
    onCancelTicket,
    onMarkTicketAsDone,
  };

  const handleNewComment = () => {
    mutate();
  };

  const isPageReady = !isLoadingTicketDetail && !isLoadingTicketFormSettings;
  const is404Error = ticketDetailError?.code === 404;

  return (
    <>
      <PortalContent>
        <TicketDetailToolbar id={id} is404Error={is404Error} />
      </PortalContent>
      {!isPageReady ? (
        <BasicLoader />
      ) : ticketDetailError ? (
        <PremiumSectionContainer>
          <PremiumSection>
            <InfoMessage>
              {is404Error ? 'Ticket not found' : 'There was an error loading the ticket'}
            </InfoMessage>
          </PremiumSection>
        </PremiumSectionContainer>
      ) : (
        <TicketPageContainer>
          <TicketForm ticketFormData={ticketFormData} />
          <LogsList logs={ticketDetail?.logs} ticketId={id} onNewComment={handleNewComment} />
        </TicketPageContainer>
      )}
    </>
  );
};

export default TicketDetailPage;
